import { createFileRoute } from '@tanstack/react-router'
// eslint-disable-next-line boundaries/element-types
import { AssetVizHeatmapDisplayState } from 'features/assetViz'
import { HealthPlans } from 'pages/healthPlans/HealthPlans'
import { z } from 'zod'

export const healthPlansSearchSchema = z.object({
  cdf: z.string().optional(),
  show3D: z.boolean().optional(),
  minFilter: z.number().optional(),
  maxFilter: z.number().optional(),
  markupLayers: z.string().optional(),
  extension: z.string().optional(),
  indication: z.string().optional(),
  heatmapDisplayState: z.nativeEnum(AssetVizHeatmapDisplayState).optional(),
})

export const Route = createFileRoute('/health-plans/$siteID')({
  component: HealthPlans,
  validateSearch: healthPlansSearchSchema,
})
